import { Layout } from "antd";
import React from "react";

const BodyAdmin = ({ children }) => {
  return (
    <Layout.Content
      style={{
        padding: "6px",
        // overflow: "auto",
        flex: "auto",
        boxSizing: "border-box",
      }}
    >
      {children}
    </Layout.Content>
  );
};

export default BodyAdmin;
